import React, {createContext, use, useEffect, useState} from "react";
import PropTypes from "prop-types";

const AICooldownContext = createContext({
  cooldownLeft: 0,
  setCooldownLeft: () => {},
});

const AICooldownProvider = ({children}) => {
  const [cooldownLeft, setCooldownLeft] = useState(0);

  useEffect(() => {
    let interval;

    if (cooldownLeft > 0) {
      interval = setInterval(() => {
        setCooldownLeft((prev) => prev - 1);
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [cooldownLeft]);

  return (
    <AICooldownContext value={{cooldownLeft, setCooldownLeft}}>
      {children}
    </AICooldownContext>
  );
};

AICooldownProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useAICooldown = () => {
  return use(AICooldownContext);
};

export default AICooldownProvider;
